<div class="page">
  <section class="hero" aria-labelledby="projectsTitle"
           [style.--hero-cover]="cover(headerData.coverBg?.large)"
           [style.--hero-cover-preview]="cover(headerData.coverBg?.small)">
    <h1 class="hero__title" id="projectsTitle">{{ headerData.title }}</h1>
    <p class="hero__desc" [innerHTML]="user ? headerData.description : headerData.unauthDescription"></p>
    @if (!user) {
      <div class="hero__actions">
        <a class="ut-btn" uiSref="signup">Join uTest</a>
      </div>
    }
  </section>

  <!-- Always visible, as on the legacy board; picking one on Suggested switches to All. -->
  <div class="board__filters" role="group" aria-label="Filter projects">
    <ut-filter-select
      class="board__field"
      label="Operating system"
      placeholder="Any operating system"
      [options]="projectInfo.os"
      [value]="os"
      (valueChange)="setFilter('os', $event)" />
    <ut-filter-select
      class="board__field"
      label="Country"
      placeholder="Any country"
      [options]="projectInfo.countries"
      [value]="country"
      (valueChange)="setFilter('country', $event)" />
    @if (hasFilters) {
      <button type="button" class="board__clear" (click)="clearFilters()">Clear filters</button>
    }
  </div>

  <div class="tabs" role="group" aria-label="Show projects">
    @for (option of tabs; track option.value) {
      @if (shouldShow(option.value)) {
        <button
          type="button"
          class="tab"
          [class.is-active]="tab() === option.value"
          [attr.aria-pressed]="tab() === option.value"
          [disabled]="isDisabled(option.value)"
          (click)="selectTab(option.value)">
          {{ option.label }}
        </button>
      }
    }
  </div>

  <p class="sr-only" role="status">{{ status }}</p>
  <div class="board__body">
    @if (store.feedItems.length) {
      <h2 class="sr-only">Projects</h2>
      <ul class="list" [attr.aria-busy]="store.isLoading">
        @for (project of store.feedItems; track project.id) {
          <li><ut-project-card [project]="project" [feed]="store"></ut-project-card></li>
        }
      </ul>
    } @else if (store.isLoading) {
      <div class="list" aria-hidden="true">
        <div class="skeleton"></div>
        <div class="skeleton"></div>
        <div class="skeleton"></div>
      </div>
    } @else if (!store.failed) {
      <div class="card empty">
        <span class="empty__icon" aria-hidden="true"><span class="material-icons">search</span></span>
        <p class="empty__title">{{ emptyTitle }}</p>
      </div>
    }

    @if (store.failed && !store.isLoading) {
      <div class="alert alert--error" role="alert">
        <span class="material-icons" aria-hidden="true">error_outline</span>
        <p class="alert__text"><b>Projects couldn't load.</b> Check your connection and try again.</p>
        <button type="button" class="ut-btn ut-btn--secondary ut-btn--sm" (click)="retry()">Retry</button>
      </div>
    } @else if (store.feedItems.length && !store.isLastPage) {
      <button type="button" class="ut-btn ut-btn--secondary more" [disabled]="store.isLoading" (click)="loadMore()">
        {{ store.isLoading ? 'Loading…' : 'View more' }}
      </button>
    }
  </div>
</div>
